import { NonBilledSessionsReportActions } from '../constants';

export interface GetNonBilledSessionsReportAction {
    type: typeof NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT;
    payload: any;
}

export function getNonBilledSessionsReport(params: any): GetNonBilledSessionsReportAction {
    return {
        type: NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT,
        payload: params,
    };
}

export interface GetNonBilledSessionsReportCsvAction {
    type: typeof NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT_CSV;
    payload: any;
}

export function getNonBilledSessionsReportCsv(params: any): GetNonBilledSessionsReportCsvAction {
    return {
        type: NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT_CSV,
        payload: params,
    };
}

export type Actions = GetNonBilledSessionsReportAction | GetNonBilledSessionsReportCsvAction;
